export default __webpack_public_path__ + "static/small-icons-dark-2c295e356599949b0d3e579c21ff69dc.png";